// Redirect users to Morrisons account
window.location.replace('https://account.morrisons.com')
